import { useIntl } from '@capsicum/common';
import { Button, CondensedButton } from '@capsicum/common-web';
import { MinusIcon, PlusIcon } from '@capsicum/common-web/icons';
import styled from 'styled-components';

export type BuySellButtonsProps = {
	fanTokenCurrencyId?: string;
	isBuyEnabled?: boolean;
	isBuyLoading?: boolean;
	isLoading?: boolean;
	isMarketAvailable: boolean;
	isSellEnabled?: boolean;
	isSellLoading?: boolean;
	onClickBuy?: (fanTokenCurrencyId?: string) => void;
	onClickSell?: (fanTokenCurrencyId?: string) => void;
	partnerId?: string;
	showBuy?: boolean;
	showSell?: boolean;
	testID?: string;
};

export const BuySellButtonsSkeleton = () => (
	<S.Container>
		<Button disabled fullWidth isLoading testID="buy-button-skeleton" />
		<Button disabled fullWidth isLoading testID="sell-button-skeleton" />
	</S.Container>
);

/**
 * @description
 * BuySellButons for Marketplace Fan Token Card,
 */
export const BuySellButtons = ({
	fanTokenCurrencyId,
	isBuyEnabled,
	isBuyLoading,
	isLoading,
	isMarketAvailable,
	isSellEnabled,
	isSellLoading,
	onClickBuy,
	onClickSell,
	partnerId,
	showBuy = true,
	showSell = true
}: BuySellButtonsProps) => {
	const { $t } = useIntl();

	if (!isMarketAvailable) return null;

	if (isLoading) {
		return <BuySellButtonsSkeleton />;
	}

	return (
		<S.Container>
			{showSell && (
				<S.Button
					color="brand"
					debouncingTime={500}
					disabled={!isSellEnabled}
					iconStart={{ icon: { iconSize: 'small', src: MinusIcon } }}
					isLoading={isSellLoading}
					key={`sell-${partnerId}`}
					size="xsmall"
					testID={`marketplace-sell-button-${partnerId}`}
					text={$t('wallet.partnerDetails.marketplace.sell')}
					textSize="xsmall"
					onClick={() => {
						onClickSell?.(fanTokenCurrencyId);
					}}
				/>
			)}

			{showBuy && (
				<S.Button
					color="brand"
					debouncingTime={500}
					disabled={!isBuyEnabled}
					iconStart={{ icon: { iconSize: 'small', src: PlusIcon } }}
					isLoading={isBuyLoading}
					key={`buy-${partnerId}`}
					size="xsmall"
					testID={`marketplace-buy-button-${partnerId}`}
					text={$t('wallet.partnerDetails.marketplace.buy')}
					textSize="xsmall"
					onClick={() => {
						onClickBuy?.(fanTokenCurrencyId);
					}}
				/>
			)}
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		width: 100%;
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		margin-top: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const Button = styled(CondensedButton)`
		min-width: 70px;
	`;
}
